"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = theme => ({
    root: {
        position: 'absolute',
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: theme.white1,
        fontSize: '0.42em',
        fontWeight: 700,
        lineHeight: 1,
        textTransform: 'uppercase'
    }
});
//# sourceMappingURL=avatar.group.initials.style.js.map